import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

export default function GamesLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="challenge" />
      <Stack.Screen name="speurtocht" />
      <Stack.Screen name="tic-tac-toe" />
      <Stack.Screen name="memory" />
    </Stack>
  );
}

